@import "~/styles/variables";

.ModalContent {
  border-radius: 0 0 $border-radius-xl $border-radius-xl;
  background: $color-white;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}
